function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  fill: "none",
  id: "canvas_background",
  height: 251,
  width: 250,
  y: -1,
  x: -1
}), /*#__PURE__*/React.createElement("g", {
  display: "none",
  overflow: "visible",
  y: 0,
  x: 0,
  height: "100%",
  width: "100%",
  id: "canvasGrid"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "url(#gridpattern)",
  strokeWidth: 0,
  y: 0,
  x: 0,
  height: "100%",
  width: "100%"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  strokeDasharray: 20,
  id: "svg_1",
  height: 213.999997,
  width: 213.999997,
  y: 18.040149,
  x: 16.8611,
  strokeWidth: 16,
  stroke: "#000",
  fill: "none"
}), /*#__PURE__*/React.createElement("ellipse", {
  ry: 39.5,
  rx: 39.5,
  id: "svg_2",
  cy: 87.605177,
  cx: 90.239139,
  strokeOpacity: "null",
  strokeWidth: 5,
  stroke: "#000",
  fill: "#000000"
}), /*#__PURE__*/React.createElement("rect", {
  id: "svg_3",
  height: 61.636373,
  width: 61.636373,
  y: 135.606293,
  x: 133.750604,
  strokeOpacity: "null",
  strokeWidth: 5,
  stroke: "#000",
  fill: "#000000"
}));

var SvgUngroup = function SvgUngroup(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 247.99999999999997,
    height: 248.99999999999997,
    viewBox: "0 0 248 249",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUngroup, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ungroup.c0dec3ae.svg";
export { ForwardRef as ReactComponent };